import React from "react";
import OutsideOrgUsersContent from "../components/users/outside-org-users-content";

const OutsideOrgUsers = () => {
  return <OutsideOrgUsersContent />;
};

export default OutsideOrgUsers;
